// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalButton_button__DZkVH {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms ease;
  width: 100%;
  white-space: nowrap;
}

/* ================= SIZE ================= */

.GlobalButton_button--large__1mQhp {
  font-size: 16px;
  height: var(--button-large-height);
  padding: 12px 24px;
}

.GlobalButton_button--medium__i5uyp {
  font-size: 14px;
  height: var(--button-medium-height);
  padding: 8px 16px;
}
.GlobalButton_button--small__zi8sR {
  font-size: 12px;
  height: var(--button-medium-height);
  padding: 4px 8px;
}

/* ================= PRIMARY ================= */

.GlobalButton_button--primary__db7Bo {
  background: var(--color-primary);
  color: var(--color-white);
  border: 1px solid var(--color-primary);
}

.GlobalButton_button--primary__db7Bo:hover {
  background: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
}

.GlobalButton_button--primary__db7Bo:active {
  background: var(--color-primary-pressed);
  border-color: var(--color-primary-pressed);
}

.GlobalButton_button--primary__db7Bo:focus-visible {
  background-color: var(--color-primary-focused);
  outline: 2px solid var(--color-primary-focused);
}

.GlobalButton_button--primary__db7Bo:disabled {
  background: var(--color-disabled);
  border-color: var(--color-disabled);
  color: var(--color-white);
  cursor: not-allowed;
}

/* ================= WARNING ================= */

.GlobalButton_button--warning__7U17T {
  color: var(--color-warning);
  border: 1px solid var(--color-warning);
}

.GlobalButton_button--warning__7U17T:hover {
  color: var(--color-white);
  background: var(--color-warning-hover);
  border-color: var(--color-warning-hover);
}

.GlobalButton_button--warning__7U17T:active {
  background: var(--color-warning-pressed);
  border-color: var(--color-warning-pressed);
}

.GlobalButton_button--warning__7U17T:focus-visible {
  color: var(--color-white);
  background-color: var(--color-warning-focused);
  outline: 2px solid var(--color-warning-focused);
}
.GlobalButton_button--warning__7U17T:disabled {
  background: var(--color-disabled);
  border-color: var(--color-disabled);
  color: var(--color-white);
  cursor: not-allowed;
}

/* ================= SECONDARY ================= */

.GlobalButton_button--secondary__hdAtk {
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
}

.GlobalButton_button--secondary__hdAtk:hover {
  color: var(--color-primary-hover);
  border: 1px solid var(--color-primary-hover);
}

.GlobalButton_button--secondary__hdAtk:active {
  color: var(--color-primary-pressed);
  border-color: var(--color-primary-pressed);
}
.GlobalButton_button--secondary__hdAtk:focus-visible {
  color: var(--color-primary-focused);
  border: 1px solid var(--color-primary-focused);
  outline: 2px solid var(--color-primary-focused);
}

.GlobalButton_button--secondary__hdAtk:disabled {
  background: var(--color-white);
  color: var(--color-disabled);
  border-color: var(--color-disabled);
  cursor: not-allowed;
}
/* ================= TERTIARY ================= */

.GlobalButton_button--tertiary__B0xHT {
  color: var(--color-primary);
}

.GlobalButton_button--tertiary__B0xHT:hover {
  color: var(--color-primary-hover);
}

.GlobalButton_button--tertiary__B0xHT:active {
  color: var(--color-primary-pressed);
}

.GlobalButton_button--tertiary__B0xHT:focus-visible {
  color: var(--color-primary-focused);
  border: 1px solid var(--color-primary-focused);
  outline: 2px solid var(--color-primary-focused);
}

/* ================= DISABLED ================= */

.GlobalButton_button--tertiary__B0xHT:disabled {
  color: var(--color-disabled);
  cursor: not-allowed;
}

.GlobalButton_spinner__sE\\+V\\+ {
  width: 20px;
  height: 20px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: GlobalButton_button-spinner__-Nifx 700ms linear infinite;
}

@keyframes GlobalButton_button-spinner__-Nifx {
  to {
    transform: rotate(360deg);
  }
}

/* ================= ICON ================= */

.GlobalButton_button__icon__tGP6s {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 768px) {
  .GlobalButton_button__DZkVH {
    gap: 8px;
    max-width: 100%;
    border-radius: 8px;
    white-space: nowrap;
  }

  .GlobalButton_button--large__1mQhp {
    height: 44px;
    font-size: 14px;
    padding: 10 34px;
    gap: 8px;
  }

  .GlobalButton_button--medium__i5uyp {
    height: 38px;
    font-size: 14px;
    padding: 8px 10px;
    gap: 8px;
  }

  .GlobalButton_button--small__zi8sR {
    height: 30px;
    font-size: 14px;
    padding: 6px 8px;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .GlobalButton_button__DZkVH {
    gap: 6px;
    border-radius: 6px;
    white-space: nowrap;
  }

  .GlobalButton_button--large__1mQhp {
    height: 40px;
    font-size: 12px;
    padding: 8px 30px;
    gap: 6px;
  }

  .GlobalButton_button--medium__i5uyp {
    height: 36px;
    font-size: 12px;
    padding: 8px 26px;
    gap: 6px;
  }

  .GlobalButton_button--small__zi8sR {
    height: 28px;
    font-size: 12px;
    padding: 6px 18px;
    gap: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/utils/GlobalButton.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;AACrB;;AAEA,6CAA6C;;AAE7C;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,gDAAgD;;AAEhD;EACE,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gDAAgD;;AAEhD;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,kDAAkD;;AAElD;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mCAAmC;EACnC,mBAAmB;AACrB;AACA,iDAAiD;;AAEjD;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,iDAAiD;;AAEjD;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,mEAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,6CAA6C;;AAE7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mDAAmD;;AAEnD;EACE;IACE,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;AACF","sourcesContent":[".button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms ease;\n  width: 100%;\n  white-space: nowrap;\n}\n\n/* ================= SIZE ================= */\n\n.button--large {\n  font-size: 16px;\n  height: var(--button-large-height);\n  padding: 12px 24px;\n}\n\n.button--medium {\n  font-size: 14px;\n  height: var(--button-medium-height);\n  padding: 8px 16px;\n}\n.button--small {\n  font-size: 12px;\n  height: var(--button-medium-height);\n  padding: 4px 8px;\n}\n\n/* ================= PRIMARY ================= */\n\n.button--primary {\n  background: var(--color-primary);\n  color: var(--color-white);\n  border: 1px solid var(--color-primary);\n}\n\n.button--primary:hover {\n  background: var(--color-primary-hover);\n  border-color: var(--color-primary-hover);\n}\n\n.button--primary:active {\n  background: var(--color-primary-pressed);\n  border-color: var(--color-primary-pressed);\n}\n\n.button--primary:focus-visible {\n  background-color: var(--color-primary-focused);\n  outline: 2px solid var(--color-primary-focused);\n}\n\n.button--primary:disabled {\n  background: var(--color-disabled);\n  border-color: var(--color-disabled);\n  color: var(--color-white);\n  cursor: not-allowed;\n}\n\n/* ================= WARNING ================= */\n\n.button--warning {\n  color: var(--color-warning);\n  border: 1px solid var(--color-warning);\n}\n\n.button--warning:hover {\n  color: var(--color-white);\n  background: var(--color-warning-hover);\n  border-color: var(--color-warning-hover);\n}\n\n.button--warning:active {\n  background: var(--color-warning-pressed);\n  border-color: var(--color-warning-pressed);\n}\n\n.button--warning:focus-visible {\n  color: var(--color-white);\n  background-color: var(--color-warning-focused);\n  outline: 2px solid var(--color-warning-focused);\n}\n.button--warning:disabled {\n  background: var(--color-disabled);\n  border-color: var(--color-disabled);\n  color: var(--color-white);\n  cursor: not-allowed;\n}\n\n/* ================= SECONDARY ================= */\n\n.button--secondary {\n  color: var(--color-primary);\n  border: 1px solid var(--color-primary);\n}\n\n.button--secondary:hover {\n  color: var(--color-primary-hover);\n  border: 1px solid var(--color-primary-hover);\n}\n\n.button--secondary:active {\n  color: var(--color-primary-pressed);\n  border-color: var(--color-primary-pressed);\n}\n.button--secondary:focus-visible {\n  color: var(--color-primary-focused);\n  border: 1px solid var(--color-primary-focused);\n  outline: 2px solid var(--color-primary-focused);\n}\n\n.button--secondary:disabled {\n  background: var(--color-white);\n  color: var(--color-disabled);\n  border-color: var(--color-disabled);\n  cursor: not-allowed;\n}\n/* ================= TERTIARY ================= */\n\n.button--tertiary {\n  color: var(--color-primary);\n}\n\n.button--tertiary:hover {\n  color: var(--color-primary-hover);\n}\n\n.button--tertiary:active {\n  color: var(--color-primary-pressed);\n}\n\n.button--tertiary:focus-visible {\n  color: var(--color-primary-focused);\n  border: 1px solid var(--color-primary-focused);\n  outline: 2px solid var(--color-primary-focused);\n}\n\n/* ================= DISABLED ================= */\n\n.button--tertiary:disabled {\n  color: var(--color-disabled);\n  cursor: not-allowed;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: button-spinner 700ms linear infinite;\n}\n\n@keyframes button-spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ================= ICON ================= */\n\n.button__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 768px) {\n  .button {\n    gap: 8px;\n    max-width: 100%;\n    border-radius: 8px;\n    white-space: nowrap;\n  }\n\n  .button--large {\n    height: 44px;\n    font-size: 14px;\n    padding: 10 34px;\n    gap: 8px;\n  }\n\n  .button--medium {\n    height: 38px;\n    font-size: 14px;\n    padding: 8px 10px;\n    gap: 8px;\n  }\n\n  .button--small {\n    height: 30px;\n    font-size: 14px;\n    padding: 6px 8px;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .button {\n    gap: 6px;\n    border-radius: 6px;\n    white-space: nowrap;\n  }\n\n  .button--large {\n    height: 40px;\n    font-size: 12px;\n    padding: 8px 30px;\n    gap: 6px;\n  }\n\n  .button--medium {\n    height: 36px;\n    font-size: 12px;\n    padding: 8px 26px;\n    gap: 6px;\n  }\n\n  .button--small {\n    height: 28px;\n    font-size: 12px;\n    padding: 6px 18px;\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `GlobalButton_button__DZkVH`,
	"button--large": `GlobalButton_button--large__1mQhp`,
	"button--medium": `GlobalButton_button--medium__i5uyp`,
	"button--small": `GlobalButton_button--small__zi8sR`,
	"button--primary": `GlobalButton_button--primary__db7Bo`,
	"button--warning": `GlobalButton_button--warning__7U17T`,
	"button--secondary": `GlobalButton_button--secondary__hdAtk`,
	"button--tertiary": `GlobalButton_button--tertiary__B0xHT`,
	"spinner": `GlobalButton_spinner__sE+V+`,
	"button-spinner": `GlobalButton_button-spinner__-Nifx`,
	"button__icon": `GlobalButton_button__icon__tGP6s`
};
export default ___CSS_LOADER_EXPORT___;
